// extracted by mini-css-extract-plugin
export default {"container":"DraftsView-module__container--fTcUg","tab":"DraftsView-module__tab--xk2nT","animatedBackground":"DraftsView-module__animatedBackground--T9voa"};